import { useState } from 'react';
import { ChevronRightIcon } from 'lucide-react';

import {
  Collapsible,
  CollapsiblePanel,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import type { TaskFileChangeView } from '@/lib/api/generated/model';
import { cn } from '@/lib/utils';

import { ALSO_CHANGED_COPY } from '../alsoChangedCopy';
import { ResultFiles } from './ResultFiles';

/**
 * What the task's runs saw change in the shared workspace but could not
 * credit to it (service spec 126): another task's run overlapped, and nothing
 * this run did named these paths. Collapsed and apart from the task's own
 * files, so it never reads as the task's work, yet nothing the capture saw is
 * hidden. The service sends one entry per path, so the count is the rows.
 */
export function AlsoChangedFiles({
  workspaceId,
  files,
}: {
  workspaceId: string;
  files: readonly TaskFileChangeView[];
}) {
  const [open, setOpen] = useState(false);
  if (files.length === 0) return null;
  const count = files.length;
  return (
    <section aria-labelledby="task-results-also-changed">
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger className="text-muted-foreground hover:text-foreground focus-visible:ring-ring flex items-center gap-1.5 rounded-sm text-sm focus-visible:ring-3 focus-visible:outline-none">
          <ChevronRightIcon
            aria-hidden="true"
            className={cn(
              'size-4 shrink-0 transition-transform',
              open ? 'rotate-90' : '',
            )}
          />
          <h3 id="task-results-also-changed" className="font-medium">
            {ALSO_CHANGED_COPY.heading(count)}
          </h3>
        </CollapsibleTrigger>
        <CollapsiblePanel className="flex flex-col gap-3 ps-5.5 pt-2">
          <p className="text-muted-foreground text-xs">
            {ALSO_CHANGED_COPY.explanation}
          </p>
          <ResultFiles workspaceId={workspaceId} files={files} />
        </CollapsiblePanel>
      </Collapsible>
    </section>
  );
}
